export const APP_NAME = "Pie Club Admin";
export const DEFAULT_MAX_WIDTH = "lg";
export const DEFAULT_QUERY_LIMIT = 50;
export const DEFAULT_DRAWER_WIDTH = 300;
export const DEFAULT_ELEVATION = 4;
export const DEFAULT_BOXES = 200;
export const DELIVERY_FEE = 15;

export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const IS_STAGING = false; // will be FALSE if it is live

export const SERVER_URL = IS_DEVELOPMENT
  ? "http://127.0.0.1:5000"
  : IS_STAGING
  ? "http://s1.fatbastardpies.nz"
  : "https://api.fatbastardpies.nz";

export const FRONT_URL = IS_DEVELOPMENT
  ? "http://localhost:3001"
  : IS_STAGING
  ? "http://s1.fatbastardpies.nz"
  : "https://club.fatbastardpies.nz";

export const FREIGHTWAY_TOKEN =
  IS_DEVELOPMENT || IS_STAGING
    ? "Basic MW9laTJodWdwOXRtNjdqYnQ0N2Y4ZzBsdmI6OW50ZG91M2kwMWNvYWJ2bGJua3EybmVzYWFibGVwazNnN3A3Mzc5aTZyazJnYzluMTZw"
    : "Basic N2JhbnI4cGFjdHVlcGxjdnBrNHNuc3F0azA6dHZoZzNzaDYyNnR2czVkbjRhMTI5NXIxaXZrOTk2cGdvMW04MDBsM2NzazJyZmxldjZo";

export const DELIVERY_KEY =
  IS_DEVELOPMENT || IS_STAGING
    ? "https://customer-integration.ep-sandbox.freightways.co.nz"
    : "https://customer-integration.ep-prod.freightways.co.nz";
export const DELIVERY_KEY_LIVE =
  "https://customer-integration.ep-prod.freightways.co.nz";

export const FREIGHTWAYS_AUTH =
  IS_DEVELOPMENT || IS_STAGING
    ? "https://auth.ep-sandbox.freightways.co.nz"
    : "https://auth.ep-prod.freightways.co.nz";

export const orderStatusOptions = [
  { id: "1", label: "Fulfilled", variant: "success" },
  { id: "0", label: "Unfulfilled", variant: "warning" },
  { id: "2", label: "Cancelled", variant: "error" },
  { id: "4", label: "Skipped", variant: "warning" },
];

export const paymentStatusOption = [
  { id: "0", label: "Pending", variant: "warning" },
  { id: "1", label: "Paid", variant: "success" },
  { id: "2", label: "Failed", variant: "error" },
  { id: "3", label: "Refund", variant: "error" },
  { id: "4", label: "Skipped", variant: "warning" },
  { id: "5", label: "Cancelled", variant: "error" },
  { id: "6", label: "Credit Re-Send", variant: "success" },
  { id: "7", label: "3D Secure", variant: "error" },
];

export const regionOption = [
  { id: "0", label: "Auckland", variant: "success" },
  { id: "1", label: "Bay of Plenty", variant: "success" },
  { id: "2", label: "Canterbury", variant: "success" },
  { id: "3", label: "Gisborne", variant: "success" },
  { id: "4", label: "Hawke's Bay", variant: "success" },
  { id: "5", label: "Manawatu-Wanganui", variant: "success" },
  { id: "6", label: "Marlborough", variant: "success" },
  { id: "7", label: "Nelson", variant: "success" },
  { id: "8", label: "Northland", variant: "success" },
  { id: "9", label: "Otago", variant: "success" },
  { id: "10", label: "Southland", variant: "success" },
  { id: "11", label: "Taranaki", variant: "success" },
  { id: "12", label: "Tasman", variant: "success" },
  { id: "13", label: "Waikato", variant: "success" },
  { id: "14", label: "Wellington", variant: "success" },
  { id: "15", label: "West Coast", variant: "success" },
];

export const refundOptions = [
  { id: "1", label: "Duplicate" },
  { id: "2", label: "Fraudulent" },
  { id: "3", label: "Requested by customer" },
  { id: "4", label: "other" },
];

export const boxStatusOptions = [
  { value: "1", label: "Active", variant: "success" },
  { value: "0", label: "Cancel", variant: "error" },
];

export const postcodes = ["9810", "9812", "9720"];
